import { STORAGE_KEYS, databaseService, routes } from '@fly/shared';
import log from 'loglevel';

import { IPlatformService } from './platform-service.interface';

export class WebPlatformService implements IPlatformService {
  private logoutFunction: ((payload?: any) => void) | null = null;
  setLogoutFunction(logout: (redirectUri?: string) => void) {
    this.logoutFunction = logout;
  }

  login(loginFn: (path?: string) => void): void {
    databaseService.clearAllData();
    loginFn(routes.DASHBOARD.REGISTRY.GIT_REPOSITORIES);
  }
  async pushNotification(payload: any): Promise<void> {
    log.info('Push Notification');
  }

  // Due to some bug with @axa-fr/react-oidc, we need to make sure the redirectUri has "?" at the end.
  logout(
    redirectUri: string = `${window.location.origin}${routes.DASHBOARD.REGISTRY.GIT_REPOSITORIES}?`
  ): void {
    localStorage.removeItem(STORAGE_KEYS.MULTIPLE_TEAMS_TOAST_SHOWN);
    databaseService.clearAllData().then(() => {
      this.logoutFunction?.(redirectUri);
    });
  }
}
